export interface KeyFrameProperty {
    name: string;
    value: string;
}

export interface KeyFrameProperties {
    x?: number;
    y?: number;
    /** Rotation, in degrees **/
    r?: number;
    /** Scale **/
    sc?: number;
    /** ScaleX **/
    sx?: number;
    /** ScaleY **/
    sy?: number;
    /** Color **/
    c?: string;
    /** Opacity **/
    o?: number;
    /** Text **/
    t?: string;
    clip?: string;
    /** Stroke **/
    str?: string;
    fill?: string;
    counter?: number;
    /** z-index **/
    z?: number;
    /** ease **/
    e?: KeyFrameEase;
}

export enum KeyFrameEase {
    Linear = 1,
    Power1EaseIn = 2,
    Power1EaseOut = 3,
    Power1EaseInOut = 4,
    Power2EaseIn = 5,
    Power2EaseOut = 6,
    Power2EaseInOut = 7,
    ElasticEaseIn = 8,
    ElasticEaseOut = 9,
    ElasticEaseInOut = 10,
}

export interface KeyFrame extends KeyFrameProperties {
    /** seconds **/
    s: number;
}

export function copyKeyFrame(k: KeyFrame): KeyFrame {
    let x = <any> {};
    copyKeyFrameTo(k, x);
    return x;
}

export function copyKeyFrameTo(from: KeyFrame, to: KeyFrame): void {
    if (from == null)
        throw "Cannot copy null or undefined keyframe";

    if (to == null)
        throw  "Cannot copy to null or undefined keyframe";

    if (from.x != null)
        to.x = +from.x;
    if (from.y != null)
        to.y = +from.y;
    if (from.r != null)
        to.r = +from.r;
    if (from.sc != null)
        to.sc = +from.sc;
    if (from.sx != null)
        to.sx = +from.sx;
    if (from.sy != null)
        to.sy = +from.sy;
    if (from.c != null && from.c.trim().length !== 0)
        to.c = from.c;
    if (from.o != null)
        to.o = +from.o;
    if (from.t != null)
        to.t = from.t;
    if (from.clip != null && from.clip.trim().length !== 0)
        to.clip = from.clip;
    if (from.counter != null)
        to.counter = from.counter;
    if (from.z != null)
        to.z = +from.z;
    if (from.str != null && from.str.trim().length !== 0)
        to.str = from.str;
    if (from.fill != null && from.fill.trim().length !== 0)
        to.fill = from.fill;
    if (from.e != null)
        to.e = +from.e;

    to.s = +from.s;
}

export function copyKeyFrameToWithRounding(from: KeyFrame, to: KeyFrame): void {
    if (from == null)
        throw "Cannot copy null or undefined keyframe";

    if (to == null)
        throw  "Cannot copy to null or undefined keyframe";

    if (from.x != null)
        to.x = +(+from.x).toFixed(5);
    if (from.y != null)
        to.y = +(+from.y).toFixed(5);
    if (from.r != null)
        to.r = +(+from.r).toFixed(2);
    if (from.sc != null)
        to.sc = +from.sc;
    if (from.sx != null)
        to.sx = +from.sx;
    if (from.sy != null)
        to.sy = +from.sy;
    if (from.c != null && from.c.trim().length !== 0)
        to.c = from.c;
    if (from.o != null)
        to.o = +from.o;
    if (from.t != null)
        to.t = from.t;
    if (from.clip != null && from.clip.trim().length !== 0)
        to.clip = from.clip;
    if (from.counter != null)
        to.counter = from.counter;
    if (from.z != null)
        to.z = +from.z;
    if (from.str != null && from.str.trim().length !== 0)
        to.str = from.str;
    if (from.fill != null && from.fill.trim().length !== 0)
        to.fill = from.fill;
    if (from.e != null)
        to.e = +from.e;

    to.s = +from.s;
}

export function expandKeyFrame(keyFrames: KeyFrame[], index: number) {
    let keyFrame = {
        s: 0,
        x: 0,
        y: 0,
        r: 0,
        sc: 1
    };

    for (let i = 0; i <= index; i++){
        let kf = keyFrames[i];
        copyKeyFrameTo(kf, keyFrame);
    }

    return keyFrame;
}